export default {
    // 主面板
    back: 'вернут',
    dd: 'д.',
    hh: 'час.',
    mm: 'мин.',
    ss: 'сек.',
    send: 'Отправить',
    detail: '详情', // 详情
    discuss: '讨论', // 讨论
    content: '目录',
    duration: '时长',
    backPlay: '回放',
    cloudHall: '展厅',
    enterprise: '企业鸣谢',
    conven: '分会场',
    discussLoginTip: 'Ваше нынешнее положение не должно принимать участия в выступлении.', // 发言登录提示
    drawLoginTip: '请登录后再参与抽奖。', // 抽奖登录提示
    feedbackLoginTip: '请登录后再进行意见反馈。', // 意见反馈登录提示
    complainLoginTip: '请登录后再进行投诉。', // 投诉登录提示
    mineLoginTip: '请登录后再查看我的资料。', // 我的资料登录提示
    toLogin: 'залогин',
    loginIn: 'Регистрация',
    guest: 'турист',
    countdown: '直播倒计时',
    widthMobile: 'мобильный телефон',
    scanWx: 'Проверь',
    // 登录框
    loginMobileTitle: 'залогин',
    loginEmailTitle: 'залогин',
    loginPhoneLabel: '手机号',
    loginPhoneTip: 'Введите',
    loginVerificationLabel: 'Код подтверждения',
    loginVerificationTip: 'Введите',
    loginNameLabel: 'ФИО',
    loginNameTip: 'Введите',
    loginCompanyLabel: 'Название организации',
    loginCompanyTip: 'Введите',
    loginOfficeLabel: 'Отделение',
    loginOfficeTip: 'Введите',
    loginInGuest: 'Наблюдение за статусом туриста',
    loginGetCode: 'Код доступа',
    areaCode: '区号',
    // 手机绑定弹框
    bindMobileTitle: '手机号绑定',
    bindLoginIn: '绑 定',
    bindSuccess: '绑定成功',
    bindFail: '绑定失败',
    // 邮箱登录框
    loginEmailLabel: 'Почтов ящик',
    loginEmailTip: 'Введите',
    correctEmialTip: 'Пожалуйста, введите правильный почтовый ящик и код проверки',
    correctLoginTip: '请输入正确的手机号和验证码',
    // 广告
    skip: 'пропуст',
    // 抽奖
    startCountdown: '开始倒计时',
    endCountdown: '结束倒计时',
    last: '剩余',
    lastDrawNums: '次抽奖机会',
    seeMyGift: '查看我的奖品',
    drawRule: '抽奖规则',
    thx: '谢谢参与',
    notstart: '未开始',
    drawNow: '立即抽奖',
    hasEnd: '已结束',
    drawnotstart: '抽奖未开始',
    drawing: '进行中',
    drawend: '抽奖已结束',
    gift: '奖品',
    drawLessNum: '抽奖次数已用完',
    draw: '抽奖',
    drawNoPerfect: '没有完善资料',
    drawGoPerfect: '尽快去完善',
    drawResult: '抽奖结果',
    drawFailTip: '很遗憾，大奖与您擦肩而过',
    congratulations: '恭喜您获得',
    perfectAddress: '完善收货信息',
    agreementTip: '我同意将以上填写的个人信息提供给活动主办方',
    emailTip: '奖品发货信息将发送到您的邮箱',
    submited: '已提交',
    name: 'ФИО',
    tel: '电话',
    telTip: '请输入电话',
    email: '邮箱',
    emailResTip: '请输入邮箱',
    address: '地址',
    addressTip: '请输入地址',
    // 时长
    currentAccount: '当前登录账号',
    noLogin: '未登录',
    noReportDuration: '未上报时长',
    reportDuration: '上报',
    totalDuration: '累计观看时长',
    RequiredViewingTime: '要求观看时长',
    RequiredViewingTimeLIVE: '要求观看直播时长',
    RequiredViewingTimeVOD: '要求观看点播时长',
    RequiredViewingTimeALL: '要求观看直播加点播时长',
    Minutes: '分钟',
    // enterStatus: '学分报名状态',
    enterStatus: '报名状态',
    applyInfo: '报名信息',
    enterYes: '已报名',
    enterNo: '未报名',
    // 姓名医院登录
    hasRead: 'Прочли и согласились следовать',
    policy: 'Соглашение о конфиденциальности',
    needCheckPolicy: 'Пожалуйста, отметьте соглашение',
    // 完善资料弹窗
    perfect: 'Регистрация',
    perfectOfficesLabel: '所在科室',
    perfectOfficesTip: '请输入所在科室',
    perfectJobLabel: '职称',
    perfectJobTip: '请输入职称',
    submit: 'представ',
    selectTypeLabel: '身份',
    selectType: '点击选择身份',
    selectHospitalLabel: 'Название организации',
    selectHospital: 'Введите',
    selectOfficeLabel: 'Отделение',
    selectOffice: 'Введите',
    selectJobTitleLabel: '职称',
    selectJobTitle: 'Введите',
    selectSchoolLabel: '学校',
    selectSchool: 'Введите',
    selectSpecialtyLabel: '专业',
    selectSpecialty: 'Введите',
    selectEducationLabel: '学历',
    selectEducation: 'Введите',
    selectUnitLabel: '单位',
    selectUnit: 'Введите',
    selectPostLabel: '职务',
    selectPost: 'Введите',
    selectSexLabel: '性别',
    selectSex: 'Введите',
    selectBirthdayLabel: '生日',
    selectBirthday: 'Введите',
    selectKeyword: '请输入搜索关键词',
    perfectTip: '注：请确认以上填写为本人真实有效信息',
    besure: 'увер',
    becancel: '取消',
    // 隐私条款
    sure: 'увер',
    // 投诉反馈
    more: '更多',
    consult: '咨询客服',
    mineTitle: '我的资料',
    complain: '投诉',
    complainReason: '请选择投诉原因',
    complainContent: '内容',
    complainContentPlaceholder: '请详细描述您遇到的问题，并上传相关页面的截图',
    complainDescPlaceholder: '请填写问题内容',
    complainImages: '截图',
    complainImagesPlaceholder: '请上传至少一张截图',
    submitQuick: 'представ',
    feedback: '意见反馈',
    feedbackTitle: '标题',
    feedbackTitlePlaceholder: '请输入标题',
    feedbackContent: '详细描述',
    feedbackContentDesc: '请填写详细描述',
    feedbackContentPlaceholder: '请详细描述您遇到的问题，并上传相关页面的截图，使得我们为您提供更好的帮助',
    feedbackImages: '上传图片',
    feedbackSubmit: 'представ',
    feedbackFail: '游客模式不允许投诉',
    // 我的资料
    mineInfo: '我的资料',
    mineSave: '保存',
    mineLogout: '退出登录',
    mineLogoutTip: '确认退出登录？',
    // 多会场
    hasNoLink: '该日程需要付费才能观看',
    // 无权限提示
    noauthTip: 'подсказк',
    logoutDesc: '确认要退出登录？',
    noauthDesc: 'Мне жаль, что у вас нет доступа к прямому эфиру, пожалуйста, свяжитесь с персоналом или перезалогинитесь',
    noauthBtn: 'Перезагрузка',
    // 其他
    verificationSuccess: 'Подтверждаю передачу',
    verificationFail: 'Код доступа к аномалии',

    erificationTypeError : 'Ошибка типа',
    verificationFrequently: 'Подтверждение слишком часто, пожалуйста, попробуйте снова через 2 минуты',

    loginSuccess: 'Получилось',
    loginFail: 'Система не работает',
    hospitalLoginValidFail: 'Имена и больницы не могут быть пустыми или пустыми',
    saveSuccess: 'Сохранилась',
    saveFail: 'Неудача в сохранении',
    perfectSuccess: 'Совершенствовать успех',
    perfectFail: 'Усовершенствовать не удалось',
    authFail: 'Доступ к прямому эфиру не удался, пожалуйста, попробуйте позже',
    appointFail: 'Встреча сорвалась',
    noLiveTip: 'В прямом эфире и воспроизведение текущей встречи нет, пожалуйста, свяжитесь с администратором',
    submitSuccess: 'success',
}
